import { render, staticRenderFns } from "./removeMemberModal.vue?vue&type=template&id=9f51ca96&scoped=true"
import script from "./removeMemberModal.vue?vue&type=script&lang=js"
export * from "./removeMemberModal.vue?vue&type=script&lang=js"
import style0 from "./removeMemberModal.vue?vue&type=style&index=0&id=9f51ca96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f51ca96",
  null
  
)

export default component.exports